import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  DOCS: {
    id: 'Docs.docs',
    defaultMessage: 'Docs',
    description: '[Type: Label][Vis.: low] - Docs link in main navigation',
  },
});

const Docs = () => {
  const url = createURL('/api/v3/', { ut_source: 'header' });
  const title = t(COPY.DOCS);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.DOCS} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.DOCS} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Docs;
export { Docs };
